import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/appointment.js";
import "@ui5/webcomponents-icons/dist/checklist.js";
import "@ui5/webcomponents-icons/dist/form.js";
import "@ui5/webcomponents-icons/dist/column-chart-dual-axis.js";
import "@ui5/webcomponents-icons/dist/settings.js";
import "@ui5/webcomponents-icons/dist/task.js";
import "@ui5/webcomponents-icons/dist/visits.js";

import { workPermissions, workSettingsGroup } from "./permissions";

/** Tasks & Forms entries of the navigation registry (group `work`, OP9-OP11). */
export const workNavigation: readonly NavigationEntry[] = [
  {
    key: "work.tasks",
    labelKey: "nav.workTasks",
    icon: "task",
    path: "/work/tasks",
    permission: workPermissions.taskView,
  },
  {
    key: "work.board",
    labelKey: "nav.workBoard",
    icon: "column-chart-dual-axis",
    path: "/work/board",
    permission: workPermissions.taskView,
  },
  {
    key: "work.calendar",
    labelKey: "nav.workCalendar",
    icon: "appointment",
    path: "/work/calendar",
    permission: workPermissions.taskView,
  },
  {
    key: "work.queues",
    labelKey: "nav.workQueues",
    icon: "visits",
    path: "/work/queues",
    permission: workPermissions.taskView,
  },
  {
    key: "work.forms",
    labelKey: "nav.workForms",
    icon: "form",
    path: "/work/forms",
    permission: workPermissions.formView,
  },
  {
    key: "work.checklists",
    labelKey: "nav.workChecklists",
    icon: "checklist",
    path: "/work/checklists",
    permission: workPermissions.checklistView,
  },
  {
    key: "work.settings",
    labelKey: "nav.workSettings",
    icon: "settings",
    path: `/platform/settings/${workSettingsGroup}`,
    permission: workPermissions.taskManage,
  },
];
